import component from '@/mixins/component'

import Draggable from 'gsap/Draggable'
import '@/js/greensock/plugins/ThrowPropsPlugin'

export default {
  name: 'push-case',
  mixins: [component],
  data () {
    return {
      needIntersection: true,
      currentIndex: 0,
      snaps: [],
      nbVisible: 0,
      margin: 0
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return []
      },
      slider: undefined
    },
    white: Boolean,
    noTitle: Boolean
  },
  mounted () {
    if (this.type === 'grid') return
    window.addEventListener('resize', this.resize)

    this.offsetWidth
    this.items.length > 3 ? this.offset = 525 : this.offset = 0
    if (this.platform !== 'mobile') {
      if ((window.innerWidth - 1100) / 2 - 525 < 0) {
        this.margin = (window.innerWidth - 1100) / 2 > 0 ? (window.innerWidth - 1100) / 2 : 0

        this.$refs['slider-container'].style.marginLeft = `${this.margin}px`
      } else {
        this.$refs['slider-container'].style.marginLeft = `0px`
      }
    } else {
      this.offset = 0
    }

    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
    if (this.$refs['slider-container']) {
      if (this.$refs['slider-container'].getBoundingClientRect().width > (window.innerWidth - 525) && this.type !== 'grid') {
        this.initDrag()
      }
    }
  },
  methods: {
    show () {
      this.$el.classList.remove('hidden')
    },
    hide () {
      this.$el.classList.add('hidden')
    },
    initDrag () {
      if (this.slider) this.slider.kill()
      let screenWidth
      let snapOffset
      (window.innerWidth - 1100) / 2 - this.offset > 0 ? snapOffset = (window.innerWidth - 1100) / 2 - this.offset : snapOffset = 0

      this.platform === 'mobile' ? screenWidth = window.innerWidth : screenWidth = (window.innerWidth)
      this.snaps = this.$refs['slider-item'].map(item => {
        const boundings = item.$el.getBoundingClientRect()
        return -(boundings.left - this.margin - snapOffset)
      })
      if (this.platform !== 'mobile') this.snaps.push(this.$refs['slider-item'][this.$refs['slider-item'].length - 1].$el.getBoundingClientRect().left + this.$refs['slider-item'][0].$el.getBoundingClientRect().width)
      this.nbVisible = Math.floor(screenWidth / this.$refs['slider-item'][0].$el.offsetWidth)

      this.slider = new Draggable(this.$refs['slider-container'], {
        type: 'x',
        edgeResistance: 0.9,
        throwProps: true,
        zIndexBoost: false,
        maxDuration: 0.5,
        bounds: {
          minX: 0,
          maxX: this.snaps[this.snaps.length - this.nbVisible]
        },
        snap: {
          x: this.snaps
        },
        onRelease: () => {
          if (this.slider.endX !== this.slider.currentEndX) {
            this.dragEndHandler(this.slider.endX)
          }
        }
      })
      if (this.platform === 'mobile') this.go(0)
      this.$refs['slider-container'].style.transform = 'translateX(Opx)'
    },
    dragEndHandler (x) {
      if (isNaN(x)) return
      x = x || 0
      this.currentIndex = this.snaps.indexOf(x)
    },
    prev () {
      this.currentIndex--
      this.go(this.currentIndex)
    },
    next () {
      this.currentIndex++
      this.go(this.currentIndex)
    },
    go (index) {
      TweenMax.to(this.$refs['slider-container'], 0.3, { x: this.snaps[index] })
    },
    resize () {
      // if (this.platform === 'mobile') {
      //   return
      // }
      if (this.platform === 'mobile') return
      if (this.platform !== 'mobile') {
        if ((window.innerWidth - 1100) / 2 - 525 < 0) {
          this.margin = (window.innerWidth - 1100) / 2 > 0 ? (window.innerWidth - 1100) / 2 : 0
          this.$refs['slider-container'].style.marginLeft = `${this.margin}px`
        } else {
          this.$refs['slider-container'].style.marginLeft = `0px`
        }
      } else {
        this.offset = 0
      }
      this.$refs['slider-container'].style.transform = 'translateX(Opx)'
      this.snaps = []
      this.currentIndex = 0
      this.nbVisible = 0

      if (this.$refs['slider-container'].getBoundingClientRect().width > (window.innerWidth - 525)) {
        this.initDrag()
      } else {
        if (this.slider) this.slider.kill()
      }
    },
    handleClick (e) {
      if (this.platform === 'desktop') {
        e.srcElement.querySelector('img').style.transition = 'transform 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940)'  
        e.srcElement.querySelector('img').style.transform = 'translate(-50%,-50%) scale(1)' 
      }
    }
  }
}
